export default __webpack_public_path__ + "static/media/warning--bridge--g2.be0cc144.png";